import React from "react";
import { Helmet } from "react-helmet";
// Screens
import Home from "./main/Home.jsx";

export default function App() {
  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@200;400;600&display=swap" rel="stylesheet" />
      </Helmet>
      <Home />
    </>
  );
}

